import { cssInterop } from "nativewind";
import Svg, { type SvgProps } from "react-native-svg";

const SvgRoot = (props: SvgProps) => <Svg {...props} />;

/**
 * An `Svg` whose colour can be set with a `text-*` or `fill-*` utility. NativeWind compiles those
 * into `color` / `fill` styles, and both are forwarded to the Svg's `color` prop — which is what
 * `currentColor` on a child `Path` resolves against.
 *
 * The mapping is deliberately bound to this wrapper rather than to `react-native-svg`'s own `Svg`.
 * Every `Icon` ends up rendering that shared component — `PrimitiveIcon` passes the icon's `style`
 * to the lucide component, which spreads it onto `Svg` — so a global registration would add a
 * second interop layer inside each icon, move the `fill` style onto a prop and delete it, and let
 * lucide's `fill: "none"` default render every `<Icon className="fill-…" />` transparent.
 */
export const StyledSvg = cssInterop(SvgRoot, {
	className: {
		target: "style",
		nativeStyleToProp: { color: true, fill: "color" },
	},
});
